var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-defi-borrow-fusd-confirmation"},[_c('defi-borrow-confirmation',{attrs:{"params":_vm.params,"token":_vm.params.token}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }